orderService.$inject = [
  '$ngRedux',
  '$http',
  '$state',
  '$timeout',
  'orderActions',
  'APP',
  'authService',
  '$cookies',
  '$stateParams'
];

export default function orderService($ngRedux, $http, $state,
  $timeout, orderActions, APP, $auth, $cookies, $stateParams) {

  this.giftCardRequest = [];

  let service = {
    getCategories,
    getTiles,
    getSubCategories,
    getProducts,
    getProductsByGroupNumber,
    getProductOfSameGroupByPrettyUrl,
    getCartDetail,
    removeCart,
    addItemToCart,
    addMultipleItemToCart,
    updateItemInCart,
    removeItemFromCart,
    getGoogleDistance,
    getShippingCharges,
    orderCheckout,
    orderGuestCheckout,
    initializePayment,
    getPaymentInfo,
    paymentSubmit,
    saveCardDetail,
    getOrderSummary,
    getRecentOrder,
    getSubscriptions,
    getSubscriptionsDetail,
    getZoneWiseDeliveryCharges,
    getZoneWiseDeliveryChargesForGuest,
    reOrder,
    buyDscMembership,
    buyGiftCard,
    getSearchResults,
    getBirdBuckCoupon,
    calculateTaxes,
    getStoreLocations,
    searchStores,
    getUserZone,
    getAvailableSubscriptionsInterval,
    getSubcribableProducts,
    updateSubscriptionsDetail,
    cancelSubscription,
    getSubscriptionConfig,
    updateCreditCard,
    removeCreditCard,
    getCouponDiscount,
    getCurrencyType,
    getPromoImage,
    getStoreFeatures,
    getBirdBucksByUser,
    getStoreDiscountMapping,
    getCateoryNamebyId,
    getSubCateoryNamebyId,
    getReferralProducts,
    getOrderPoints,
    getGiftCards,
    validateGiftCardDetails,
    getOrderAmount,
    isIpad,
    paymentUsingGiftCards,
    paymentUsingStoreCredit,
    isGiveXAvailable,
    getItemTaxDetails,
    getPaymentKeys,
    getHeartlandPaymentCharge,
    setGiftCardRequest,
    getGiftCardRequest,
    initializePaymentHeartland,
    paymentSubmitHeartland,
    updateCardHeartland,
    getErplyBirdBucksByUser,
    getErplyCartDetail,
    doErplyZeroDollarTransaction,
    dscPremembership,
    deleteDscPremembership,
    getGuestCartDetail,
    initializePaymentTsys,
    paymentSubmitTsys,
    paymentSubmitMoneris,
    initializePaymentMoneris,
    monerisProcess,
    updateCardTsys,
    canSaveUserCard,
    updateCardMoneris,
    getProductByPrettyUrl,
    getMultipleImage,
    getReferrals,
    getDSCDetails,
    updateUserAction,
    updateUserActionFromOrder,
    saveRemainder,
    remainderUsed,
    printPaymentLogs,
    doGuestOptIn,
    printCustomerGenericLogs,
    getLinksByMasterId,
    checkAndUpdateStoreCreditAmount,
    paypalCreateOrder,
    paypalCreateOrderReturnUser,
    paypalCaptureOrder,
    savePaypalAuthorizedOrder,
    paypalCreateVaultOrder
  };
  return service;

  function isIpad() {
    return ( this.$window.innerWidth < 1248 && this.$window.innerWidth > 767 );
  }

  function base() {
    return APP.ORDER.ORDER_URL;
  }
  function hostUrl() {
    if ($auth.isGuestLogin()) {
      return '/guest';
    }
    return '';
  }

  function getCategories() {
    return $http.get(hostUrl() + base().root + base().category)
      .then(success => $ngRedux.dispatch(orderActions.setCategories(success.data)));
  }

  function getTiles() {
    return $http.get(hostUrl() + base().root + base().tiles)
    .then(success => $ngRedux.dispatch(orderActions.setTiles(success.data)));
  }

  function getSubCategories(id) {
    return $http.get(`${hostUrl() + base().root}/category/${id}${base().subCategory}`)
      .success(success => $ngRedux.dispatch(orderActions.setSubCategories(success)));
  }

  function getProducts(categoryId,subCategoryId) {
    // if($cookies.get('storeId')){
    return $http.get(`${hostUrl() + base().root}/category/${categoryId}/subcategory/${subCategoryId}${base().product}`)
      .success(success => $ngRedux.dispatch(orderActions.setProducts(success)));
  }

  function getProductsByGroupNumber(categoryId,subCategoryId,itemGroupNumber) {
    var url = '';
   if(itemGroupNumber){
    url = `${hostUrl() + base().root}/category/${categoryId}/subcategory/${subCategoryId}${base().product+'?itemGroupNumber='+itemGroupNumber}`;
   } else {
    url = `${hostUrl() + base().root}/category/${categoryId}/subcategory/${subCategoryId}${base().product}`;
   }
    return $http.get(url)
      .success(success => $ngRedux.dispatch(orderActions.setProducts(success)));
  }

  function getProductOfSameGroupByPrettyUrl(subCategoryId,prettyUrl) {
    var url = '';
    url = `${hostUrl() + base().root}/subcategory/${subCategoryId}/item/${prettyUrl}`;
    return $http.get(url)
      .success(success => $ngRedux.dispatch(orderActions.setProducts(success)));
  }

  function getProductByPrettyUrl(categoryId,subCategoryId, productId) {
    return $http.get(`${hostUrl() + base().root}/category/${categoryId}/subcategory/${subCategoryId}/item/${productId}`)
      .success(success => $ngRedux.dispatch(orderActions.setProducts(success)));
  }

  function getCartDetail(isCartPage) {
    if(isCartPage==undefined){
      isCartPage = true;
    }
    return $http.get(`${base().root}${base().cart.base}?isCartPage=${isCartPage}`)
      .success(success => $ngRedux.dispatch(orderActions.setCartDetail(success)))
      .error(() => $ngRedux.dispatch(orderActions.setCartDetail({
        cartItems: []
      })));
  }

  function getErplyCartDetail(data) {
    // return $http.post(`${base().root}${base().cart.erplyBase}`)
    return $http.post(base().root+base().cart.erplyBase,data)
      .success(success => $ngRedux.dispatch(orderActions.setCartDetail(success)))
      .error(() => $ngRedux.dispatch(orderActions.setCartDetail({
        cartItems: []
      })));
  }  

  function getGuestCartDetail(data) {
    return $http.post(`${base().root}${base().cart.base}/guest`, data)
      .success(success => $ngRedux.dispatch(orderActions.setCartDetail(success)))
      .error(() => $ngRedux.dispatch(orderActions.setCartDetail({
        cartItems: []
      })));
  }

  function getItemTaxDetails(orderRequest) {
    // return $http.post(base().root+base().cart.tax,orderRequest)
    //   .success(success => $ngRedux.dispatch(orderActions.setTaxDetail(success)))
    //   .error(() => $ngRedux.dispatch(orderActions.setTaxDetail({
    //     cartTaxItems: []
    //   })));
    return $http.post(base().root+base().cart.tax,orderRequest);
  }

  function removeCart() {
    try{
      sessionStorage.removeItem('discountCoupon');
      sessionStorage.removeItem('birdbuckCoupon');
      sessionStorage.removeItem('erplyBBDiscount');
      sessionStorage.removeItem('erplyPromotionDiscount');
      sessionStorage.removeItem('orderNotesSession');
       }
   catch (e) {           
              $cookies.remove('discountCoupon');
              $cookies.remove('birdbuckCoupon');
              $cookies.remove('erplyBBDiscount');
              $cookies.remove('erplyPromotionDiscount');
              $cookies.remove('orderNotesSession');
            }
    return $http.post(base().root + base().cart.base + base().cart.remove);
  }

  function addItemToCart(quantity, id,subCategoryId) {
    return $http.post(
      `${base().root}${base().cart.base}/item/${subCategoryId}/${id}${base().cart.add}?quantity=${quantity}`
    );
  }
  function addMultipleItemToCart(data) {
    return $http.post(`${base().root}${base().cart.base}/item/addItems`, data);
  }

  function updateItemInCart(quantity, id, subCategoryId) {
    return $http.post(
      `${base().root}${base().cart.base}/item/${subCategoryId}/${id}${base().cart.update}?quantity=${quantity}`
    );
  }

  function removeItemFromCart(id) {
    return $http.post(
      `${base().root}${base().cart.base}/item/${id}${base().cart.remove}`
    );
  }

  function getGoogleDistance(data) {
    delete $http.defaults.headers.common['X-Requested-With'];
    return $http.get('https://maps.googleapis.com/maps/api/distancematrix/json?origins=' +
      `${data.store.addressLine1}, ${data.store.city}, ${data.store.state.name}` +
      `&destinations=${data.shippingAddressLine1}, ${data.shippingCity}, ${data.shippingState.name}` +
      '&mode=driving&language=fr-FR&key=AIzaSyApwGHe4vFBVU-SO1Cb0NgXmPQ3w_gr9oE');
  }

  function getShippingCharges() {
    return $http.get(base().shippingCharge)
      .success(success => $ngRedux.dispatch(orderActions.setShippingCharges(success)));
  }

  function orderCheckout(data) {
    return $http.post(base().root + base().checkout, data);
  }

  function orderGuestCheckout(data) {
    return $http.post(base().root + base().guestCheckout, data)
    .success(success => {
        sessionStorage.setItem('guestoauth', success.userToken);
        sessionStorage.setItem('isGuestUserLoggedIn', success.isGuestUser);
    });
  }

  function initializePayment(id, device, data) {
    return $http.post(`${base().root}${base().order.base}/${id}/${device}${base().order.initPayment}`,data);
  }

  function getPaymentInfo() {
    return $http.get(`${base().root}${base().paymentInfo}`)
      .success(success => $ngRedux.dispatch(orderActions.setPaymentInfo(success)));
  }

  function saveCardDetail(id) {
    return $http.post(`${base().root}/payment/${id}/info`);
  }

  function paymentSubmit(orderId, cardId, cardNo, data) {
    return $http.post(`${base().root}/order/${orderId}/card/${cardId}/${cardNo}/pay`, data);
  }

  function getOrderSummary(id) {
    return $http.get(`${base().root}${base().order.base}/${id}${base().order.summary}`)
      .success(success => $ngRedux.dispatch(orderActions.setOrderDetail(success)));
  }

  function getRecentOrder() {
    return $http.get(`${base().root}${base().order.base}${base().order.recentOrder}`)
      .success(success => $ngRedux.dispatch(orderActions.setRecentOrder(success)));
  }

  function getZoneWiseDeliveryCharges() {
    return $http.get('/api/v1/customer/shipping/charge/all')
    .then(success => $ngRedux.dispatch(orderActions.setZoneWiseDeliveryCharges(success.data)));
  }

  function getZoneWiseDeliveryChargesForGuest() {
    return $http.get('/api/v1/customer/shipping/charge/all/guest')
    .then(success => $ngRedux.dispatch(orderActions.setZoneWiseDeliveryCharges(success.data)));
  }

  function reOrder(orderId) {
    return $http.put(`${base().root}${base().order.base}/${orderId}${base().order.reOrder}`);
  }

  function buyDscMembership() {
    return $http.post('/api/v1/customer/cart/buy/dsc/membership/88888888');
  }

  function buyGiftCard(quantity,masterCode) {
    return $http.post('/api/v1/customer/gift/buy/'+masterCode+'/'+quantity );
  }

  function getSubscriptions() {

    return $http.get('/api/v1/customer/subscription/all')
            .then(success => $ngRedux.dispatch(orderActions.setSubscriptions(success.data)));
  }
  function getAvailableSubscriptionsInterval(){
    return $http.get('/api/v1/customer/intervals')
            .then(success => $ngRedux.dispatch(orderActions.setAvailableSubscriptionsInterval(success.data)));
  }
  function getSubscriptionConfig(){
    return $http.get('/api/v1/customer/subscriptionconfig')
            .then(success => $ngRedux.dispatch(orderActions.setSubscriptionConfig(success.data)));
  }
  function getSubscriptionsDetail(id) {
    return $http.get('/api/v1/customer/subscription?subscriptionId=' + id)
            .then(success => $ngRedux.dispatch(orderActions.setSubscriptionsDetail(success.data)));
  }

  function getSearchResults(searchTerm) {
    return $http.get(hostUrl() + '/api/v1/customer/item/search?searchParam=' + searchTerm)
    .then(success => $ngRedux.dispatch(orderActions.setSearchResults(success.data)));
  }

 //  Old Birdbuck Coupon Code
 // function getBirdBuckCoupon(coupon) {
 //   return $http.get('/api/v1/customer/birdbucks/coupon/' + coupon)
 //   .then(success => {
 //     $ngRedux.dispatch(orderActions.setBirdBuckCoupon(success.data));
 //     return success.data;
 //   });
 //  }

  function calculateTaxes(params) {
    return $http.post('/api/v1/customer/getTaxableAmount', params)
    .then(success => $ngRedux.dispatch(orderActions.setTaxes(success.data)));
  }

  function getStoreLocations() {
    return $http.get('/api/v1/customer/all/store/location')
    .then(success => $ngRedux.dispatch(orderActions.setStoreLocations(success.data)));
  }
  function getPromoImage(storeCode) {
    // let guestStore = null;
    // try {
    //   guestStore = sessionStorage.getItem('guestStoreName');
    // }
    // catch (e) {
    //   guestStore = $cookies.get('guestStoreName');
    // }
    // if( guestStore || $stateParams.storeName ){
    // return $http.get('/api/v1/customer/store/'+storeCode+'/promos/get')
    // .then(success => $ngRedux.dispatch(orderActions.setPromoImage(success.data))); 
    // } else {
      return $http.get('/api/v1/customer/promos/get')
    .then(success => $ngRedux.dispatch(orderActions.setPromoImage(success.data))); 
    // }
  }

  function getStoreFeatures() {
    return $http.get('/api/v1/store/features')
  .then(success => $ngRedux.dispatch(orderActions.setStoreFeatures(success.data))); 
}

  function searchStores(data) {
    return $http.post('/api/v1/customer/storelocator/getnearbystores', data)
    .then(success => $ngRedux.dispatch(orderActions.setStoreLocations(success.data)));
  }
  function updateSubscriptionsDetail(data){
    return $http.post('/api/v1/customer/subscription/update',data);
  }
  function getUserZone(data) {
    return $http.post('/api/v1/customer/fedex/getratezone', data)
            .then(success => $ngRedux.dispatch(orderActions.setUserShippingZoneInfo(success.data)));
  }
  function getSubcribableProducts(){
    return $http.get(hostUrl() + '/api/v1/customer/subscriptionAvailItems')
            .then(success => $ngRedux.dispatch(orderActions.setSubscribableProducts(success.data)));
  }
  function cancelSubscription(orderId) {
    return $http.post(`${base().root}/subscription/cancel?subscriptionId=${orderId}`);
  }  
  function updateCreditCard(id,device) {
    return $http.post(`${base().cards.base}/${id}/${device}${base().cards.update}`);
  }
  function removeCreditCard(id) 
  {
	  return $http.post(`${base().root}${base().cards.card}/${id}${base().cards.remove}`);
  }

  function getCouponDiscount(id,isInStorePickUp,shipToStateId)
  {
    
     return $http.get(`${base().root}${base().discount.amount}${id}&isInstorePickuP=${isInStorePickUp}&shipToStateId=${shipToStateId}`).then(success => { (

      $ngRedux.dispatch(orderActions.setDiscountCoupon(success.data))  );
      
       try {
        sessionStorage.setItem('discountCoupon', id);

      }
      catch (e) {
        $cookies.put('discountCoupon', id, {
          secure: true,
          samesite: 'lax'
        });

      }

    },
    error => {
       try {
         sessionStorage.removeItem('discountCoupon');
      }
      catch (e) {
        $cookies.remove('discountCoupon');
      }
      throw error;
    })
    .catch(error => {
       try {
         sessionStorage.removeItem('discountCoupon');
      }
      catch (e) {
        $cookies.remove('discountCoupon');
      }
        throw error;
    });
  }
  function getBirdBuckCoupon(coupon)
  {
    
    return $http.get('/api/v1/customer/birdbucks/coupon/' + coupon).then(success => { (

      $ngRedux.dispatch(orderActions.setBirdBuckCoupon(success.data)) );
      
       try {
        sessionStorage.setItem('birdbuckCoupon', coupon);

      }
      catch (e) {
        $cookies.put('birdbuckCoupon', coupon, {
          secure: true,
          samesite: 'lax'
        });

      }

    },
    error => {
       try {
         sessionStorage.removeItem('birdbuckCoupon');
      }
      catch (e) {
        $cookies.remove('birdbuckCoupon');
      }
      throw error;
    })
    .catch(error => {
       try {
         sessionStorage.removeItem('birdbuckCoupon');
      }
      catch (e) {
        $cookies.remove('birdbuckCoupon');
      }
        throw error;
    });
  }
  function getCurrencyType(country)
  {
    return `${base().currencyType[country]}`;
   
  }

  function getBirdBucksByUser(userId) {
    return $http.get('/api/v1/customer/birdbucks')
    .then(success => $ngRedux.dispatch(orderActions.setBirdBucksByUser(success.data)));
  }

  function getStoreDiscountMapping(discountCode) {
    return $http.get('/api/v1/customer/discounts/'+discountCode+'/storemap')
      .then(success => $ngRedux.dispatch(orderActions.setStoreDiscountMap(success.data)));
  }

  function getSubCateoryNamebyId(subCategoryId) {

    
    return $http.get(hostUrl() + base().root + '/item/name/false/url/' +subCategoryId);
  }

  function getCateoryNamebyId(categoryId) {

    
    return $http.get(hostUrl() + base().root + '/item/name/true/url/' +categoryId);

  }

  function getReferralProducts(masterCode) {
    return $http.get(hostUrl() + base().root + '/product/referral/' + masterCode)
    .then(success => $ngRedux.dispatch(orderActions.setReferralProducts(success.data)));
  }

  function getOrderPoints(data) {
       return $http.post(hostUrl() + base().root + '/getorderpoints',data)
       .then(success => $ngRedux.dispatch(orderActions.setOrderPoints(success.data)));
  }

  function getGiftCards() {
    return $http.get(hostUrl() + base().root + '/gifts/all')
    .then(success => $ngRedux.dispatch(orderActions.setGiftCards(success.data)));
  }
  
  function validateGiftCardDetails(data) {
    return $http.post(base().root + '/getgiftcardbalance',data);
  }

  function getOrderAmount(id) {
    return $http.get(base().root + '/order/'+id);
  }

  function paymentUsingGiftCards(data) {
    return $http.post(base().root + '/orderusinggiftcards', data);
  }

  function paymentUsingStoreCredit(data) {
    return $http.post(base().root + '/orderusingstorecredit', data);
  }

  function isGiveXAvailable(data) {
    return $http.get(base().root + '/isgivexavailable');
  }
  function getPaymentKeys() {
    return $http.get(base().root + '/payment/keys');
  }
  function getHeartlandPaymentCharge(data) {
    return $http.post(hostUrl() + base().root + '/payment/charge');
  }
  
  // getter and setter for giftCardRequest
  function setGiftCardRequest(giftCardRequest){
    this.giftCardRequest=giftCardRequest;
  }

  function getGiftCardRequest(){
    return this.giftCardRequest;
  }

  function  initializePaymentHeartland(data) {
    return $http.post(base().root + base().heartland + base().order.initPayment,data);
  }

  function  initializePaymentTsys(data) {
    return $http.post(base().root + base().tsys + base().order.initPayment,data);
  }

  function  initializePaymentMoneris(data) {
    return $http.post(base().root + base().moneris + base().order.initPayment,data);
  }

  function  monerisProcess(data) {
    return $http.post(base().root + base().moneris + base().order.payment  + base().cards.monerisProcess,data);
  }

  function paymentSubmitHeartland(data) {
    return $http.post(base().root + base().heartland + base().order.savedPayment, data);
  }

  function paymentSubmitTsys(data) {
    return $http.post(base().root + base().tsys + base().order.savedPayment, data);
  }

  function paymentSubmitMoneris(data) {
    return $http.post(base().root + base().moneris + base().order.savedPayment, data);
  }

  function  updateCardHeartland(data) {
    console.log(base().root + base().heartland + base().cards.heartlandUpdate);
    return $http.post(base().root + base().heartland + base().cards.heartlandUpdate ,data);
  }

  function  updateCardTsys(data) {
    console.log(base().root + base().tsys + base().cards.heartlandUpdate);
    return $http.post(base().root + base().tsys + base().cards.heartlandUpdate ,data);
  }

  function  updateCardMoneris(data) {
    console.log(base().root + base().moneris + base().cards.heartlandUpdate);
    return $http.post(base().root + base().moneris + base().cards.heartlandUpdate ,data);
  }

  function getErplyBirdBucksByUser(userId) {
    return $http.get('/api/v1/customer/erply/getIssuedCoupons')
    .then(success => $ngRedux.dispatch(orderActions.setErplyBirdBucksByUser(success.data)));
  }

  function doErplyZeroDollarTransaction(orderId) {
    return $http.post('/api/v1/customer/erply/payment/order/'+orderId+'/zerodollar');
  }

  function dscPremembership() {
    return $http.post('/api/v1/customer/cart/dsc/pre-membership');
  }

  function deleteDscPremembership() {
    return $http.delete('/api/v1/customer/cart/dsc/pre-membership');
  }

  function canSaveUserCard(canSave) {
    return $http.post(base().root + '/card/'+canSave);
  }
  function getMultipleImage(id) {
    return $http.get(`/api/v1/masterproduct/${id}/multi_images/get`);
  }
  function getReferrals(masterCode) {
    return $http.get(hostUrl() + base().root + '/product/referral/' + masterCode);
  }

  function getDSCDetails() {
    return $http.get('/api/v1/customer/dsc/details');
  }

  function updateUserAction(userAction, comments) {
    return $http.post('/api/v1/analytics/action/'+userAction, comments);
  }

  function updateUserActionFromOrder(userAction, orderId) {
    return $http.post('/api/v1/analytics/action/'+userAction+'/order/'+orderId);
  }

  function saveRemainder(remainderType,remainder) {
    return $http.post('/api/v1/customer/remainder/' + remainderType, remainder);
  }

  function remainderUsed(id) {
     $http.post('/api/v1/customer/remainder/used?id=' + id);
  }
  
  function printPaymentLogs(orderId,data,comments) {
    return $http.post('/api/v1/customer/payment/print/'+orderId+'/logs?comments='+comments, data);
  }

  function printCustomerGenericLogs(dataValue) {

    var stringData = {};
    stringData.config = {};
    if(dataValue && dataValue.config) {
      stringData.config.data = JSON.stringify(dataValue.config.data);
      stringData.config.headers = JSON.stringify(dataValue.config.headers);
      stringData.config.method = JSON.stringify(dataValue.config.method);
      stringData.config.url = JSON.stringify(dataValue.config.url);
    }
    if(dataValue && dataValue.data) {
      stringData.data = {};
      stringData.data.diagnostic =  JSON.stringify(dataValue.data.diagnostic);
      stringData.data.message =  JSON.stringify(dataValue.data.message);
      stringData.data.httpCode =  JSON.stringify(dataValue.data.httpCode);
    }
    return $http.post('/api/v1/customer/print/logs', stringData);
  }

  function getLinksByMasterId(id) {
    return $http.get(`/api/v1/links/masterproduct/${id}`);
  }

  function checkAndUpdateStoreCreditAmount(storeCreditValue) {
    return $http.post('/api/v1/customer/storecredit/amount',storeCreditValue);
  }

  function paypalCreateOrder(data) {
    return $http.post(base().root + base().paypal + '/createorder',data);
  }

  function paypalCreateOrderReturnUser(data) {
    return $http.post(base().root + base().paypal + '/returnuser/createorder',data);
  }

  function paypalCreateVaultOrder(data) {
    return $http.post(base().root + base().paypal + '/order/vault',data);
  }

  function paypalCaptureOrder(data) {
    return $http.post(base().root + base().paypal + '/captureorder',data);
  }
  
  function savePaypalAuthorizedOrder(data) {
    return $http.post(base().root + base().paypal + '/order/authorized',data);
  }
  function doGuestOptIn(data) {
    $http.post('/api/v1/customer/guest/opt-in',data);
  }

}



// WEBPACK FOOTER //
// ./src/app/order/service.js